import { action, computed, makeObservable, observable } from 'mobx';
import { FullScreenState } from 'src/domains/casino/state/AppCasino/game-modal/FullScreen.state';
import { getAccountRoute } from 'src/domains/casino/utils/utils';
import { Common } from 'src/domains/common/Common';
import { PopupState } from 'src/domains/layouts/state/popupState/PopupState';
import { XtremePushPopup } from 'src/domains/layouts/state/popupState/popupTypes';
import { StarRouter } from 'src/domains/layouts/state/router/StarRouter';

export class XtremePushState {
    private starRouter: StarRouter;
    private fullScreenState: FullScreenState;
    @observable public isDepositOpened: boolean;
    @observable public url: string;

    public constructor(
        private common: Common,
        private popupState: PopupState
    ) {
        makeObservable(this);
        this.fullScreenState = new FullScreenState();
        this.starRouter = StarRouter.get(this.common);
        this.isDepositOpened = false;
        this.url = '';

        this.starRouter.onChangeAccountView((prevAccountView, nextAccountView) => {
            const prevAccountRoute = getAccountRoute(prevAccountView);
            const nextAccountRoute = getAccountRoute(nextAccountView);

            if (prevAccountRoute !== nextAccountRoute) {
                if (prevAccountRoute !== 'deposit' && nextAccountRoute === 'deposit') {
                    this.onDepositOpen();
                }
                if (prevAccountRoute === 'deposit' && nextAccountRoute !== 'deposit') {
                    this.onDepositClose();
                }

                if (
                    prevAccountRoute === 'login' &&
                    nextAccountRoute !== 'login' &&
                    this.common.session.isAuthorized === false
                ) {
                    setTimeout(() => {
                        this.closeGame();
                    });
                }
            }
        });
    }
    private get userId(): number | null {
        return this.common.session.userId;
    }

    private get isUserAuthorized(): boolean {
        return this.common.session.isAuthorized;
    }

    @action public goToLoginForm = (): boolean => {
        if (this.isUserAuthorized === false) {
            setTimeout(() => {
                this.starRouter.redirectToLogin();
            }, 0);
            return true;
        }

        return false;
    };

    @action public redirectToDepositPage = (): void => {
        this.starRouter.redirectToTopUp(null);
    };

    public setRef = (ref: HTMLElement | null): void => {
        this.fullScreenState.setRef(ref);
    };

    @computed public get isFullScreen(): boolean {
        return this.fullScreenState.isFullScreen;
    }

    @action public toggleFullScreen = (): void => {
        this.fullScreenState.toggleFullscreen();
    };

    @action public closeGame = (): void => {
        this.popupState.hide();
        this.fullScreenState.clearFullScreen();
    };

    @action private onDepositOpen = (): void => {
        this.forceCloseFullScreen();

        setTimeout(() => {
            // Prevents blink on animation start
            this.isDepositOpened = true;
        }, 200);
    };

    @action private onDepositClose = (): void => {
        this.isDepositOpened = false;
    };

    @action private forceCloseFullScreen = (): void => {
        if (this.isFullScreen) {
            this.fullScreenState.toggleFullscreen();
        }
    };

    @action public startGame = (type: 'casino' | 'sportsbook'): void => {
        if (this.goToLoginForm()) {
            return;
        }

        if (this.userId === null) {
            return;
        }

        this.url = this.getUrl(type);
        this.popupState.show(new XtremePushPopup(() => this.isDepositOpened));
    };

    private getUrl = (type: 'casino' | 'sportsbook'): string => {
        if (type === 'casino') {
            return `https://wheels.games.xtremepush.com/play/5971/the-wheel-jan26-cloned?token=${this.userId}`;
        }
        return `https://penalty-shootout.games.xtremepush.com/play/5971/penaltyshootout-jan26-cloned?token=${this.userId}`;
    };
}
